import { Box } from "@material-ui/core";
import React, { useEffect } from "react";
import { getDefaultProductVariant } from "../../../helpers/product";
import { ProductType } from "../../../types/airgraft";
import ProductDetailsOverview from "./components/Overview";
import { generateOilDynamicContentModules } from "./utils";
import ProductDetailsContentModules from "./components/content-modules";
import { analyticsTrackProductView } from "../../../services/analytics";
import ContentModules from "../../../content-modules";
import fastCompare from "react-fast-compare";

type Props = {
  product: ProductType;

  /**
   * Is this product details component being rendered in a modal? See
   */
  isModal?: boolean;
};

function ProductDetails({ product, isModal }: Props) {
  const productVariant = getDefaultProductVariant(product);

  // Product details content modules
  let contentModules = productVariant.modules;

  // Dynamic content modules based on oil details
  if (
    product.productType === "oil" &&
    productVariant.variantDetail?.coaReport
  ) {
    // Add generated content modules, then custom datocms content modules
    contentModules = [
      ...generateOilDynamicContentModules(productVariant),
      ...contentModules
    ];
  }

  // On load: Trigger "view_item" ecommerce analytics event
  useEffect(() => {
    analyticsTrackProductView(product);
  }, []);

  return (
    <Box marginY={{ xs: 4, md: 4 }} data-testid="product-details">
      {/* Product overview */}
      <Box mb={{ xs: 4, md: 8 }}>
        <ProductDetailsOverview product={product} isModal={isModal} />
      </Box>

      {/* Product Content modules */}
      <ProductDetailsContentModules contentModules={contentModules} />

      {/* General Content modules */}
      <ContentModules contentModules={contentModules} />
    </Box>
  );
}

export default React.memo(ProductDetails, fastCompare);
